// extracted by mini-css-extract-plugin
export default {"oneCard":"Todo_oneCard__bdwP4","complete":"Todo_complete__ZCMwI","incomplete":"Todo_incomplete__H49mv"};